import React from 'react';

// components
import ContactAgentForm from '../../forms/contact-agent-form/contact-agent-form';

let PropertyDetailContactAgentForm = props => {
  return <ContactAgentForm {...props} hideCancel />;
};

export default PropertyDetailContactAgentForm;



// WEBPACK FOOTER //
// ./src/containers/PropertyDetail/PropertyDetailContactAgentForm.js